<template>

	<footer id="Footer" :class="this.$route.name">

		<Nav />

		<Language />

	</footer>

</template>

<script>
	import Nav from "./Nav";
	import Language from "./Language";


	export default {

		components: {
			Nav,
			Language
		}

	};

</script>